import { Card, CardContent } from "@/components/ui/card";

import { UserLogsTable } from "./components/user-logs-table";

export const UserLogsPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold tracking-tight dark:text-white">User Logs</h2>
        </div>
      </div>
      <Card>
        <CardContent>
          <UserLogsTable />
        </CardContent>
      </Card>
    </div>
  );
};
